module.exports = __webpack_public_path__ + "static/media/GBR Care Infographic Desktop 04-03-2024 .beb43ab8.gif";